import React from 'react';
import Home from '../views/Home';

const HomeContainer = (props) => {
    return (
        <Home/>
    );
};

export default HomeContainer;